import React, { useState, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';

import TextInput from 'components/TextInput';
import {
  Suggestion,
  SuggestionsContainer,
  AddressLookupContain
} from './CreateStyled';

import {
  updateOrder,
  fetchAddressSuggestions,
  clearAddressSuggestions
} from 'actions/orders';

export const AddressLookup = ({
  order,
  loading,
  onSelect,
  updateOrder,
  clearAddressSuggestions,
  fetchAddressSuggestions
}) => {
  const handleAddressSearch = useCallback(
    (query) => {
      query.length <= 3 ? clearAddressSuggestions() : fetchAddressSuggestions(query);
    },
    [clearAddressSuggestions, fetchAddressSuggestions]
  );

  const debounceHandleSuggestions = useMemo(
    () => debounce(handleAddressSearch, 500),
    [handleAddressSearch]
  );

  const [focused, setFocus] = useState(false);
  const [state, setState] = useState({});

  const handleFocus = () => setFocus(true);
  const handleBlur = () => setFocus(false);

  const handleChange = (name, value) => {
    setState((values) => ({ ...values, [name]: value }));
    debounceHandleSuggestions(value);
  };

  const handleAddressSelect = (address) => {
    const values = {
      address_lot: address.lotNo || '',
      address_unit: address.unit || '',
      address_street_no: address.streetNumber,
      address_street_1: address.streetOne,
      address_street_2: address.streetTwo || '',
      address_suburb: address.suburb,
      address_state: address.state,
      address_postcode: address.postcode
    };

    setState({});
    updateOrder(values);
    onSelect(values);

    clearAddressSuggestions();
  };

  const renderAddressSuggestions = () =>
    order.council_addresses &&
    order.council_addresses.map((address) => (
      <Suggestion
        key={address.display}
        onMouseDown={handleAddressSelect.bind(null, address)}
      >
        {address.display}
      </Suggestion>
    ));

  return (
    <AddressLookupContain>
      <TextInput
        bold
        name="address"
        onBlur={handleBlur}
        onFocus={handleFocus}
        onChange={handleChange}
        value={state.address}
        disableAutoComplete
        placeholder="Enter the property address"
      />

      {!loading && focused && !!order.council_addresses && !!order.council_addresses.length && (
        <SuggestionsContainer>{renderAddressSuggestions()}</SuggestionsContainer>
      )}
    </AddressLookupContain>
  );
};

AddressLookup.defaultProps = {
  onSelect: () => null
};

const mapDispatchToProps = {
  updateOrder,
  fetchAddressSuggestions,
  clearAddressSuggestions
};

const mapStateToProps = (state) => ({
  order: state.pendingOrder.pending,
  loading: state.loading.loadingAddresses
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddressLookup);
